enum FileTypes {
    TDF = 0,
    SOF = 1,
    DOF = 2
}

export default FileTypes;